module.exports = __webpack_public_path__ + "img/04d.e50191ae.gif";